import React, { useState, useEffect } from "react";
import { VehicleCard } from "../../../../common-components/vehicle-display-cross-module/components";
import { colors } from "../../../../../themes/Colors";
import {
  BaseButtons,
  DropDownWithDisplay,
  TextInputField,
} from "../../../../common-components";
import { TransferKeyPopUp } from "./components";

const dummyMakes = [
  { name: "BMW", imageLink: "link here" },
  { name: "VW", imageLink: "link here" },
  { name: "TOYATA", imageLink: "link here" },
  { name: "HYUNDAI", imageLink: "link here" },
  { name: "AUDI", imageLink: "link here" },
  { name: "GWM", imageLink: "link here" },
  { name: "MERCEDES", imageLink: "link here" },
  { name: "JEEP", imageLink: "link here" },
  { name: "ALPHA ROMEO", imageLink: "link here" },
  { name: "FIAT", imageLink: "link here" },
  { name: "DODGE", imageLink: "link here" },
  { name: "FORD", imageLink: "link here" },
];

const dummySeries = [
  { name: "320i", make: "bmw", imageLink: "link here" },
  { name: "320d", make: "bmw", imageLink: "link here" },
  { name: "180i", make: "bmw", imageLink: "link here" },
  { name: "180d", make: "bmw", imageLink: "link here" },
  { name: "m", make: "bmw", imageLink: "link here" },
  { name: "m3", make: "bmw", imageLink: "link here" },
  { name: "m1", make: "bmw", imageLink: "link here" },
  { name: "m2", make: "bmw", imageLink: "link here" },
  { name: "m4", make: "bmw", imageLink: "link here" },
];

const ManageVehiclePopUp = ({
  activeView,
  setActiveView,
  SubmitHandler,
  regsitrationNr,
  setRegistrationNr,
  vinNr,
  setVinNr,
  licenceNr,
  setLicenceNr,
  engineNr,
  setEngineNr,
  make,
  setMake,
  series,
  setSeries,
  selectedVehicle,
  tableDisplay,

  setSelectedVehicle,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const [selectedMake, setSelectedMake] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState(false);
  const [opened, setOpened] = useState(null);
  const [vehicleOwner, setVehicleOwner] = useState(null);

  console.log("selectedVehicle", selectedVehicle);

  const [keyTransferPopUp, setkeyTransferPopUp] = useState(false);

  const GetVehicleOwner = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/getVehicleOwner",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: selectedVehicle.vehicleOwnerUuid,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setVehicleOwner(respnseData.vehicleOwner);
      }
    } catch (err) {
      // setPopUpTitle("FAILURE");
      // setMessage(
      //   "Error occured contact support but make sure you have network first"
      // );
      // setToastPop(true);
    }
  };

  useEffect(() => {
    if (selectedVehicle && tableDisplay === "driverVehicles") {
      GetVehicleOwner();
    }
  }, [selectedVehicle]);

  useEffect(() => {
    if (selectedVehicle) {
      setSelectedSeries(selectedVehicle.series);
      setSelectedMake(selectedVehicle.make);
    }
  }, [selectedVehicle]);
  return (
    <div
      style={{
        height: activeView === "manage" ? "100%" : 0,
        width: "100%",
        //   borderStyle: "solid",
        // borderRadius: 15,
        //   borderColor: colors.primaryBlue,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transition: "height 0.3s",
        position: "absolute",
        bottom: 0,
        backgroundColor: colors.white,
        zIndex: 400,
      }}
    >
      <div
        style={{
          flex: 1,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              flex: 0.5,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",

              height: "100%",
            }}
          >
            {tableDisplay === "driverVehicles" ? null : (
              <div
                style={{
                  marginTop: 120,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                ENATIS VEHICLE DATA
              </div>
            )}
            <div
              style={{
                height: 200,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: tableDisplay === "driverVehicles" ? 10 : 0,
              }}
            >
              {tableDisplay === "driverVehicles" ? (
                <VehicleCard
                  registrationNr={
                    selectedVehicle ? selectedVehicle.registerNumber : "loading"
                  }
                  vin_nr={
                    selectedVehicle ? selectedVehicle.vinNumber : "loading"
                  }
                  licenceNr={
                    selectedVehicle ? selectedVehicle.licenceNr : "none"
                  }
                  engineNr={
                    selectedVehicle ? selectedVehicle.engineNumber : "loading"
                  }
                  make={selectedVehicle ? selectedVehicle.make : "loading"}
                  series={selectedVehicle ? selectedVehicle.series : "loading"}
                  notList={true}
                />
              ) : (
                <VehicleCard
                  registrationNr={
                    selectedVehicle ? selectedVehicle.registerNumber : "loading"
                  }
                  vin_nr={
                    selectedVehicle ? selectedVehicle.vinNumber : "loading"
                  }
                  licenceNr={
                    selectedVehicle ? selectedVehicle.licenceNr : "none"
                  }
                  engineNr={
                    selectedVehicle ? selectedVehicle.engineNumber : "loading"
                  }
                  make={selectedVehicle ? selectedVehicle.make : "loading"}
                  series={selectedVehicle ? selectedVehicle.series : "loading"}
                  notList={true}
                />
              )}
            </div>
            {tableDisplay === "driverVehicles" ? null : (
              <div style={{ flex: 1, width: "100%" }}>
                <DropDownWithDisplay
                  title={"MAKE"}
                  tagline={"(Select the make of your vehicle)"}
                  data={dummyMakes}
                  selected={selectedMake}
                  setSelected={setSelectedMake}
                  opened={opened}
                  setOpened={setOpened}
                  makeDropDown={true}
                />
                <DropDownWithDisplay
                  title={"SERIES"}
                  tagline={"(Select your vehicles series)"}
                  data={dummySeries}
                  selected={selectedSeries}
                  setSelected={setSelectedSeries}
                  opened={opened}
                  setOpened={setOpened}
                  seriesDropDown={true}
                />
              </div>
            )}

            {tableDisplay === "driverVehicles" ? (
              <div
                style={{
                  height: 220,
                  width: "80%",
                  borderStyle: "solid",
                  marginLeft: 5,
                  borderRadius: 8,
                  marginTop: 20,
                  borderColor: colors.greenLight,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    marginTop: 10,
                    fontSize: 16,
                    fontWeight: "bold",
                    marginLeft: 10,
                    width: "95%",
                  }}
                >
                  CURRENT OWNER
                </div>

                <TextInputField
                  mini={true}
                  labelTitle={"CONTACT NAME"}
                  width={"100%"}
                  size={"80%"}
                  readOnly={true}
                  value={vehicleOwner ? vehicleOwner.firstName : "loading"}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"CONTACT INFO"}
                  width={"100%"}
                  size={"80%"}
                  readOnly={true}
                  value={vehicleOwner ? vehicleOwner.cellNumber : "loading"}
                />
              </div>
            ) : null}
          </div>
          <div
            style={{
              flex: 0.5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              // backgroundColor:colors.greenLight
            }}
          >
            <div style={{ marginBottom: 20, fontSize: 16, fontWeight: "bold" }}>
              BASIC INFORMATION
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderStyle: "solid",
                borderWidth: 3,
                borderColor: colors.greenLight,
                width: "80%",
                borderRadius: 8,
                height: "56%",
                marginBottom: 40,
              }}
            >
              <TextInputField
                mini={true}
                labelTitle={"Registration Nr"}
                width={"100%"}
                size={"70%"}
                marginTop={0}
                readOnly={tableDisplay === "driverVehicles" ? true : false}
                value={
                  selectedVehicle ? selectedVehicle.registerNumber : "loading"
                }
              />
              <TextInputField
                mini={true}
                labelTitle={"Vin Nr"}
                width={"100%"}
                size={"70%"}
                readOnly={tableDisplay === "driverVehicles" ? true : false}
                value={selectedVehicle ? selectedVehicle.vinNumber : "loading"}
              />
              <TextInputField
                mini={true}
                labelTitle={"Licence Nr"}
                width={"100%"}
                size={"70%"}
                readOnly={tableDisplay === "driverVehicles" ? true : false}
                value={
                  selectedVehicle ? selectedVehicle.liscenseNumber : "loading"
                }
              />
              <TextInputField
                mini={true}
                labelTitle={"Engine Nr"}
                width={"100%"}
                size={"70%"}
                readOnly={tableDisplay === "driverVehicles" ? true : false}
                value={
                  selectedVehicle ? selectedVehicle.engineNumber : "loading"
                }
              />
            </div>
          </div>
        </div>
        {/* back and close buttons */}
        <div style={{ position: "absolute", top: 10, left: 10 }}>
          <BaseButtons
            label={"CLOSE"}
            width={100}
            backgroundColor={colors.secondaryOrange}
            onClick={() => {
              setActiveView("catalog");
              setVehicleOwner(null);
              setSelectedVehicle(null);
            }}
            borderRadius={4}
          />
        </div>
        {/* next and complete buttons */}
        <div style={{ position: "absolute", top: 10, right: 10 }}>
          {tableDisplay === "driverVehicles" ? (
            <div
              style={{
                display: "flex",
                // width: "80%",
                justifyContent: "space-evenly",
                alignItems: "center",
                position: "absolute",
                top: 0,
                right: 0,
              }}
            >
              <BaseButtons
                label={"VIEW HISTORY"}
                borderRadius={8}
                backgroundColor={colors.greenDark}
                disabled={true}
              />
              <div style={{ width: 10 }} />
              <BaseButtons
                label={"REQUEST INFORMATION"}
                borderRadius={8}
                backgroundColor={colors.greenDark}
                width={150}
                disabled={true}
              />
              <div style={{ width: 10 }} />
              <BaseButtons
                label={"REQUEST ACCESS"}
                borderRadius={8}
                backgroundColor={colors.greenDark}
                disabled={true}
              />
            </div>
          ) : (
            <div style={{ display: "flex" }}>
              <BaseButtons
                label={"TRANSFER KEYS"}
                width={140}
                backgroundColor={colors.secondaryDarkBlue}
                borderRadius={4}
                onClick={() => setkeyTransferPopUp(true)}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtons
                label={"SAVE CHANGES"}
                width={140}
                backgroundColor={colors.secondaryDarkBlue}
                borderRadius={4}
                onClick={() => SubmitHandler()}
              />
            </div>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: 20,
            fontSize: 18,
            fontWeight: "bold",
            color: colors.secondaryDarkBlue,
            left: 140,
          }}
        >
          {tableDisplay === "driverVehicles"
            ? "USER REGISTERED VEHICLE"
            : "MANAGE VEHICLE ENATIS DATA"}
        </div>
      </div>
      <TransferKeyPopUp
        display={keyTransferPopUp}
        onCloseClick={() => setkeyTransferPopUp(false)}
        setKeyTransferPop={setkeyTransferPopUp}
        auth={auth}
        setLoading={setLoading}
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setToastPop={setToastPop}
        setRefresh={setRefresh}
        refresh={refresh}
        data={selectedVehicle}
      />
    </div>
  );
};

export default ManageVehiclePopUp;
